// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { Table } from 'react-bootstrap';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import moment from 'moment';
import '../../../styles/components/UserList.css';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { isMobileResolution } from '../../../infrastructure/utils/common';
import AccomodationListMobile from './AccomodationListMobile';

export default class AccomodationList extends React.PureComponent {
  handleOnClick = event => {
    event.preventDefault();
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleOnClick } = this.props;
    handleOnClick(event.currentTarget.getAttribute('data-eventId'));
  };

  getReservationDates = (event, tz) => {
    let checkIn = '';
    let checkOut = '';
    if (event.timeTBD) {
      checkIn = 'TBD';
      checkOut = 'TBD';
    } else if (!event.dateTBD) {
      checkIn = moment(event.startTime).tz(tz).format('MM/DD/YYYY hh:mm A z');
      checkOut = moment(event.endTime).tz(tz).format('MM/DD/YYYY hh:mm A z');
    }
    return { checkIn, checkOut };
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { events, tz } = this.props;
    if (isMobileResolution()) {
      return (
        <AccomodationListMobile
          events={events}
          tz={tz}
          handleOnClick={this.handleOnClick}
          getReservationDates={this.getReservationDates}
        />
      );
    }
    return (
      <div className='eventlist'>
        <Table hover>
          <thead>
            <tr>
              <th>Check-in</th>
              <th>Check-out</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {events.map(event => {
              const { checkIn, checkOut } = this.getReservationDates(event, tz);
              return (
                <tr
                  key={event.eventId}
                  data-eventId={event.eventId}
                  className='listrow'
                  onClick={this.handleOnClick}
                >
                  <td style={{ width: '30%' }}>{checkIn}</td>
                  <td style={{ width: '30%' }}>{checkOut}</td>
                  <td style={{ width: '40%' }}>{event.eventName}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}
